import { Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfirmationDialog } from '../../../../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { setItemPackageAction } from '../../../../../../../store/order/confirm-package-order/confirm-package.actions';

@Component({
  selector: 'app-drop-all-confirm',
  standalone: true,
  imports: [ConfirmationDialog],
  templateUrl: './drop-all-confirm.html',
})
export class DropAllConfirm {
  private locale = inject(LOCALE_ID);
  private store = inject(Store);

  isArabic = computed(() => this.locale.startsWith('ar'));

  itemId = input.required<string>();
  itemType = input<'offer' | 'bundle'>('offer');

  closed = output<void>();
  dropped = output<void>();

  isLoading = signal(false);

  onCancel() {
    this.closed.emit();
  }

  onSubmit() {
    this.store.dispatch(
      setItemPackageAction({
        itemId: this.itemId(),
        itemType: this.itemType(),
        action: 'DROP',
      }),
    );
    this.dropped.emit();
    this.closed.emit();
  }
}
